export const menuAuthMap = [
  // 个人中心
  { path: "/systemMenu/individualCenter", permission: "menu:center" },
  // 公司模块
  {
    path: "/systemMenu/companyMaterials",
    permission: "menu:company:material",
  },
  { path: "/systemMenu/companyUser", permission: "menu:company:user" },
  {
    path: "/systemMenu/companyCharacter",
    permission: "menu:company:character",
  },
  {
    path: "/systemMenu/companyDepartment",
    permission: "menu:company:department",
  },
  // 工单模块
  {
    path: "/systemMenu/workOrderDetails",
    permission: "menu:workOrder:workOrder",
  },
  {
    path: "/systemMenu/processedParts",
    permission: "menu:workOrder:processedParts",
  },
  {
    path: "/systemMenu/machineTools",
    permission: "menu:workOrder:machineTools",
  },
  {
    path: "/systemMenu/productionLine",
    permission: "menu:workOrder:productionLine",
  },
  // 智能柜模块
  {
    path: "/systemMenu/cabinetCargoAisle",
    permission: "menu:cabinet:cabinetCargoAisle",
  },
  {
    path: "/systemMenu/lowInventoryCargoAisle",
    permission: "menu:cabinet:lowInventoryCargoAisle",
  },
  {
    path: "/systemMenu/cabinetMaterials",
    permission: "menu:cabinet:cabinetMaterials",
  },
  {
    path: "/systemMenu/lowInventoryMaterials",
    permission: "menu:cabinet:lowInventoryMaterials",
  },
  {
    path: "/systemMenu/cabinetDocuments",
    permission: "menu:cabinet:cabinetDocuments",
  },
  {
    path: "/systemMenu/cabinetUsers",
    permission: "menu:cabinet:cabinetUsers",
  },
  {
    path: "/systemMenu/boundAlreadyCabinet",
    permission: "menu:cabinet:boundAlreadyCabinet",
  },
  // 接口模块
  {
    path: "/systemMenu/tripartiteInterface",
    permission: "menu:interface:registration",
  },
  {
    path: "/systemMenu/notSynchronizedData",
    permission: "menu:interface:notSynchronized",
  },
  // 系统设置
  {
    path: "/systemMenu/allCabinet",
    permission: "menu:system:allCabinet",
  },
  {
    path: "/systemMenu/mainAccountRole",
    permission: "menu:system:mainAccountRole",
  },
  { path: "/systemMenu/mainAccount", permission: "menu:system:mainAccount" },
  {
    path: "/systemMenu/setPermission",
    permission: "menu:system:permission",
  },
];

// 获取【第一个有权限的菜单路由】
export function getFirstAuthRoute(userPermissions) {
  const validPermissions = Array.isArray(userPermissions)
    ? userPermissions
    : [];

  if (validPermissions.length === 0) {
    return "/401Page";
  }
  const firstMenu = menuAuthMap.find((menu) => {
    return validPermissions.includes(menu.permission);
  });

  return firstMenu ? firstMenu.path : "/401Page";
}
